import api from './api';

export const userService = {
    // Obtener perfil
    getProfile: async () => {
        const response = await api.get('/dashboard/profile');
        return response.data;
    },

    // Obtener estadísticas del dashboard
    getDashboardStats: async () => {
        const response = await api.get('/dashboard/stats');
        return response.data;
    },

    // Obtener actividad reciente
    getRecentActivity: async (limit = 10) => {
        const response = await api.get(`/dashboard/recent-activity?limit=${limit}`);
        return response.data;
    },

    // Obtener datos para gráficos
    getChartData: async () => {
        const response = await api.get('/dashboard/chart-data');
        return response.data;
    },

    // Actualizar perfil (para futuras funcionalidades)
    updateProfile: async (userData) => {
        const response = await api.put('/users/me', userData);
        return response.data;
    }
};